import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_STIDestDetailReverseScan = _resolveComponent("STIDestDetailReverseScan")!
  const _component_DetailOldSTIDest = _resolveComponent("DetailOldSTIDest")!

  return (_ctx.isReverseScanSTIDest)
    ? (_openBlock(), _createBlock(_component_STIDestDetailReverseScan, { key: 0 }))
    : (_openBlock(), _createBlock(_component_DetailOldSTIDest, { key: 1 }))
}